/* eslint-disable  */
import { debounce } from "lodash";
import moment from "moment";
import React, { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { bindActionCreators } from "redux";
import { format } from "timeago.js";
import { Search } from "lucide-react";
import Loader from "../../Components/Loader";
import { dataActionCreators } from "../../services/Actions";
import RenderLoanPage from "../RenderLoanPage";
import { ToastContainer, toast } from "react-toastify";

function LoansPaid() {
  const history = useHistory();
  const dispatch = useDispatch();
  const { GetAppliedLoans, ResetDataResponse } = bindActionCreators(dataActionCreators, dispatch);
  const [checkSouthLoan, setCheckSouthLoan] = useState(false);
  const [checkNorthLoan, setCheckNorthLoan] = useState(false);
  const [search, setSearch] = useState(null);
  const [limit, setLimit] = useState(25);
  const data = useSelector((state) => state?.data);
  const status = "paid";

  const [currentItems, setCurrentItems] = useState(null);
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const itemsPerPage = limit;
  const [currentPage, setCurrentPage] = useState(0);

  const { appliedLoans, paginate, isLoading, response } = data;

  let sectorSeleted = "";

  useEffect(() => {
    const endOffset = itemOffset + itemsPerPage;
    console.log(`Loading items from ${itemOffset} to ${endOffset}`);
    setCurrentItems(appliedLoans?.slice(itemOffset, endOffset));
    setPageCount(Number(paginate?.total));
  }, [itemOffset, itemsPerPage, appliedLoans]);

  const handlePageClick = (event) => {
    console.log("event", event);
    GetAppliedLoans(true, event.selected + 1, limit, status);
    console.log("currentPage", currentPage);
    const newOffset = (event.selected * itemsPerPage) % paginate?.total;
    setItemOffset(newOffset);
  };

  const handleSouthChange = () => {
    setCheckSouthLoan(!checkSouthLoan);
    setCheckNorthLoan(false);
  };

  const handleNorthChange = () => {
    setCheckNorthLoan(!checkNorthLoan);
    setCheckSouthLoan(false);
  };

  const onSearchTextChange = debounce((e) => {
    if (e?.target?.value) {
      setSearch(e?.target?.value ?? null);
      GetAppliedLoans(
        true,
        1,
        limit,
        status,
        `${e?.target?.value ? "&search=" + e?.target?.value : ""}`
      );
    } else {
      setSearch(null);
      GetAppliedLoans(true, 1, limit, status);
    }
  }, 800);

  const Northern = checkNorthLoan && "Northern";
  const Southern = checkSouthLoan && "Southern";

  if (checkNorthLoan) {
    sectorSeleted = "North";
  } else if (checkSouthLoan) {
    sectorSeleted = "South";
  } else {
    sectorSeleted = "No";
  }

  useEffect(() => {
    GetAppliedLoans(true, 1, limit, status);
    setCheckNorthLoan(false);
    setCheckSouthLoan(false);
  }, []);

  useEffect(() => {
    if (Northern && Southern) {
      GetAppliedLoans(true, 1, limit, status);
    } else if (Northern) {
      GetAppliedLoans(
        true,
        1,
        limit,
        status,
        `${Northern ? "&filter=" + "Northern" : ""}`
      );
    } else if (Southern) {
      GetAppliedLoans(
        true,
        1,
        limit,
        status,
        `${Southern ? "&filter=" + "Southern" : ""}`
      );
    } else {
      GetAppliedLoans(true, 1, limit, status);
    }
  }, [Southern, Northern]);

  useEffect(() => {
    GetAppliedLoans(
      true,
      1,
      limit,
      status,
      `${Northern ? "&filter=" + "Northern" : ""}`
    );
  }, [Northern]);

  useEffect(() => {
    if (response?.state === "SUCCESS") {
      toast.success(response?.message);
      setTimeout(() => {
        ResetDataResponse();
      }, 1500);
    } else if (response?.state === "ERROR") {
      toast.error(response?.message);
      setTimeout(() => {
        ResetDataResponse();
      }, 1500);
    }
  }, [response?.state]);

  return (
    <RenderLoanPage title="Paid Loans">
      {isLoading && <Loader />}

      {/* SEARCH & FILTER BAR */}
      <div className="flex flex-col sm:flex-row gap-4 mb-6">
        <div className="flex-1">
          <div className="relative">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={18} />
            <input
              type="search"
              placeholder="Search by Staff ID.."
              className="w-full pl-10 pr-4 py-2.5 bg-white border border-slate-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent shadow-sm"
              onChange={onSearchTextChange}
            />
          </div>
        </div>
        <div className="flex items-center gap-3">
          <button
            onClick={handleSouthChange}
            className={`px-4 py-2 rounded-xl text-sm font-semibold transition-all ${checkSouthLoan ? "bg-indigo-600 text-white shadow-md" : "bg-white border border-slate-200 text-slate-600 hover:bg-slate-50"}`}
          >
            South
          </button>
          <button
            onClick={handleNorthChange}
            className={`px-4 py-2 rounded-xl text-sm font-semibold transition-all ${checkNorthLoan ? "bg-indigo-600 text-white shadow-md" : "bg-white border border-slate-200 text-slate-600 hover:bg-slate-50"}`}
          >
            North
          </button>
          <select
            className="px-4 py-2.5 bg-white border border-slate-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 shadow-sm"
            onChange={(e) => setLimit(e.target.value)}
          >
            <option value={25}>25 per page</option>
            <option value={30}>30 per page</option>
            <option value={50}>50 per page</option>
            <option value={100}>100 per page</option>
            <option value={200}>200 per page</option>
            <option value={300}>300 per page</option>
          </select>
        </div>
      </div>

      {/* TABLE */}
      <section className="bg-white rounded-2xl shadow-sm border border-slate-100 overflow-hidden">
        {/* <div className="p-6 border-b border-slate-50">
          <h2 className="text-xs font-bold text-slate-800">Paid Loans</h2>
        </div> */}

        <div className="overflow-x-auto">
          <table className="w-full text-left border-collapse">
            <thead>
              <tr className="dark:bg-gray-800 bg-slate-50">
                <th className="px-6 py-4 text-xs font-bold text-slate-500 uppercase tracking-wider">Member Info</th>
                <th className="px-6 py-4 text-xs font-bold text-slate-500 uppercase tracking-wider">Loan Amount</th>
                <th className="px-6 py-4 text-xs font-bold text-slate-500 uppercase tracking-wider">Date</th>
                <th className="px-6 py-4 text-xs font-bold text-slate-500 uppercase tracking-wider">Status</th>
                <th className="px-6 py-4 text-xs font-bold text-slate-500 uppercase tracking-wider">Sector</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {appliedLoans?.length > 0 ? (
                appliedLoans.map((loan) => (
                  <tr key={loan?._id} className="hover:bg-slate-50/80 transition-colors">
                    <td className="px-6 py-4">
                      <div className="flex items-center gap-3">
                        {loan?.user?.profile_image ? (
                          <img className="w-10 h-10 rounded-full border border-slate-200 object-cover shadow-sm" src={loan?.user?.profile_image} alt="Profile" />
                        ) : (
                          <>
                            {loan?.user?.name?.split(" ")[0] === "Mr." ? (
                              <img className="w-10 h-10 rounded-full border border-slate-200 object-cover shadow-sm" src="/images/dev/avarta2.jpeg" alt="Profile" />
                            ) : (
                              <img className="w-10 h-10 rounded-full border border-slate-200 object-cover shadow-sm" src="/images/dev/woman-avarta.jpeg" alt="Profile" />
                            )}
                          </>
                        )}
                        <div>
                          <p className="text-sm font-bold text-slate-800 leading-tight">{loan?.user?.name}</p>
                          <p className="text-xs font-medium text-slate-500">{loan?.staff_id}</p>
                        </div>
                      </div>
                    </td>
                    <td className="px-6 py-4">
                      <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold bg-emerald-50 text-emerald-700 border border-emerald-100">&#8373;{loan?.loanAmount}</span>
                      <p className="text-xs text-slate-400 mt-1">MD: {loan?.monthlyDeduction}</p>
                    </td>
                    <td className="px-6 py-4">
                      <p className="text-sm text-slate-600 font-medium">{moment(loan?.created_at).format("MMM DD, YYYY")}</p>
                      <p className="text-xs text-slate-400">{format(loan?.created_at)}</p>
                    </td>
                    <td className="px-6 py-4">
                      <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold bg-green-50 text-green-700 border border-green-100">
                        {loan?.status}
                      </span>
                    </td>
                    <td className="px-6 py-4">
                      <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold border ${loan?.sector === "Northern" ? "bg-red-50 text-red-700 border-red-100" : "bg-blue-50 text-blue-700 border-blue-100"}`}>
                        {loan?.sector}
                      </span>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" className="px-6 py-12 text-center text-slate-400 italic">
                    No {sectorSeleted !== "No" ? sectorSeleted : ""} paid loans at the moment.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {appliedLoans?.length > 0 && (
          <div className="border-t border-slate-100">
            <ReactPaginate
              breakLabel="..."
              nextLabel=">"
              onPageChange={handlePageClick}
              pageRangeDisplayed={5}
              pageCount={pageCount}
              previousLabel="<"
              renderOnZeroPageCount={null}
              containerClassName="flex items-center justify-center gap-1 py-4"
              pageLinkClassName="px-3 py-1.5 rounded-lg text-sm font-medium text-slate-600 hover:bg-indigo-50 hover:text-indigo-600 transition-colors"
              previousLinkClassName="px-3 py-1.5 rounded-lg text-sm font-medium text-slate-600 hover:bg-indigo-50 hover:text-indigo-600 transition-colors"
              nextLinkClassName="px-3 py-1.5 rounded-lg text-sm font-medium text-slate-600 hover:bg-indigo-50 hover:text-indigo-600 transition-colors"
              activeLinkClassName="!bg-indigo-600 !text-white shadow-sm"
            />
          </div>
        )}
      </section>
      <ToastContainer autoClose={3000} />
    </RenderLoanPage>
  );
}

export default LoansPaid;
